export default __webpack_public_path__ + "static/media/gel-top.a4644ba9.svg";